export const AMAZON_ID = "^amzn[1-9]\\.([A-Za-z0-9]+)([-\\.][A-Za-z0-9]+)*$";
export const CRISPS_INSURANCE_ID = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$";
export const PCS_INSURANCE_ID = "^[a-f0-9]{24}$";

// Pharmacy customer identifiers.
//   Person ID:  amzn1.actor.person.oid.A1IYNXBD5N66PZ
//   Profile ID: amzn1.pharmacy.profile.id.015947e6-5615-4f5e-bd30-b4159c8892d4
export const PERSON_ID_REGEX = /^amzn1\.actor\.person\.oid\.[A-Za-z0-9]+$/;
export const PROFILE_ID_REGEX =
  /^amzn1\.pharmacy\.profile\.id\.[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export type PharmacyIdentitySource = "personId" | "profileId";

/**
 * Classifies a raw identifier string as a Person ID or Profile ID by shape, or null when it matches
 * neither. Whitespace is ignored. Reuse this anywhere a single input must accept either identifier.
 */
export function determineIdentitySource(value: string): PharmacyIdentitySource | null {
  const v = (value || "").trim();
  if (PERSON_ID_REGEX.test(v)) return "personId";
  if (PROFILE_ID_REGEX.test(v)) return "profileId";
  return null;
}